import Svg from "@/components/Svg";

const CLIP_ID = "clip0_order_tests_icon";

export default function OrderTestsIcon({ size = 38, color = "#1A1A1A" }) {
  return (
    <Svg
      as="svg"
      width={size}
      height={size}
      minWidth={size}
      minHeight={size}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#${CLIP_ID})`}>
        <path
          d="M15.2187 18.7716C15.5604 18.4299 16.073 18.3287 16.5191 18.5132C16.9652 18.6978 17.2553 19.1334 17.2563 19.6154C17.2553 20.0974 16.9652 20.533 16.5191 20.7175C16.073 20.9021 15.5604 20.8008 15.2187 20.4591C14.7525 19.9929 14.7525 19.2378 15.2187 18.7716ZM36.3126 14.5528C36.089 14.7764 35.7852 14.903 35.4688 14.903C35.1524 14.903 34.8487 14.7764 34.6251 14.5528L33.7813 13.7091L16.9062 30.5842C15.0974 32.393 12.4616 33.0987 9.99064 32.4372C7.52053 31.7749 5.5905 29.8449 4.9281 27.3747C4.26681 24.9035 4.97241 22.2678 6.78113 20.4591L23.6562 3.58401L22.8125 2.74025C22.3463 2.27407 22.3463 1.51893 22.8125 1.05274C23.2787 0.586555 24.0338 0.586555 24.5 1.05274L36.3126 12.8653C36.5362 13.0889 36.6628 13.3927 36.6627 13.7091C36.6627 14.0255 36.5362 14.3293 36.3126 14.5528ZM25.3437 5.27152L17.7499 12.8653L24.5 19.6154L32.0938 12.0216L25.3437 5.27152ZM15.2187 28.8967L22.8125 21.3029L16.0624 14.5528L8.46862 22.1466C6.60498 24.0103 6.60498 27.0331 8.46862 28.8967C10.3323 30.7603 13.355 30.7603 15.2187 28.8967ZM10.9999 24.6779C10.6582 24.3362 10.1456 24.235 9.69945 24.4195C9.2533 24.6041 8.96328 25.0397 8.96223 25.5217C8.96329 26.0037 9.25332 26.4393 9.69945 26.6238C10.1456 26.8084 10.6582 26.7071 10.9999 26.3654C11.2235 26.1418 11.35 25.8381 11.35 25.5217C11.35 25.2053 11.2235 24.9015 10.9999 24.6779ZM15.6407 23.4121C15.299 23.0704 14.7864 22.9692 14.3402 23.1538C13.8941 23.3383 13.6041 23.7739 13.603 24.2559C13.6041 24.7379 13.8941 25.1735 14.3402 25.358C14.7864 25.5426 15.299 25.4414 15.6407 25.0996C15.8643 24.8761 15.9908 24.5723 15.9908 24.2559C15.9908 23.9395 15.8643 23.6357 15.6407 23.4121Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id={CLIP_ID}>
          <rect
            width="19.092"
            height="33.7492"
            fill="white"
            transform="translate(23.8643) rotate(45)"
          />
        </clipPath>
      </defs>
    </Svg>
  );
}
